import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import CurrencyInput from "react-currency-input";
import { URLBunge } from "./Componentes/Config";
import {
  LogAcesso,
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Swal from "sweetalert2";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoDescPesquisa,
  CampoFormCadastro,
  FormPesquisa,
  DescCampo,
  BotaoEnviarPesquisa,
  BtIcoBuscar,
  CampoFormBusca,
  ClienteProdutoSelecionado,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  BtCheckBox,
  EndLinha01,
  EndLinha02,
  EndLinha03,
  EndLinha04,
  DescCampo2,
  DescCampo3,
} from "./Estilos";

import IcoBusca from "./Images/ico_search_branco.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";
import { Input } from "@material-ui/core";

function AcademiaFormularioAtendimento(props) {
  const history = useHistory();
  const location = useLocation();
  const [Loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();
  const [ListaProdutos, setListaProdutos] = useState([]);

  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));
  const [Cargo, setCargo] = useState(localStorage.getItem("c_cargo"));
  const [PrecoPao, setPrecoPao] = useState(0);
  const [ClienteSelecionado, setClienteSelecionado] = useState(false);
  const [ProdutoSelecionado, setProdutoSelecionado] = useState(false);
  const [ClienteNome, setClienteNome] = useState("");
  const [ClienteCPNJ, setClienteCPNJ] = useState("");
  const [ClienteSAP, setClienteSAP] = useState("");
  const [ClienteID, setClienteID] = useState("");
  const [ProdutoNome, setProdutoNome] = useState("");
  const [ProdutoMarca, setProdutoMarca] = useState("");
  const [ProdutoPeso, setProdutoPeso] = useState("");
  const [ProdutoCategoria, setProdutoCategoria] = useState("");
  const [ProdutoID, setProdutoID] = useState("");
  const [ClienteMostra, setClienteMostra] = useState(false);
  const [DadosClienteFlatlist, setDadosClienteFlatlist] = useState([]);
  const [ProdutoMostra, setProdutoMostra] = useState(false);
  const [DadosProdutoFlatlist, setDadosProdutoFlatlist] = useState([]);
  const [CarregandoBusca, setCarregandoBusca] = useState(true);
  const [CheckBoxEndereco, setCheckBoxEndereco] = useState(false);
  const [TextoAguarde, setTextoAguarde] = useState(false);
  const [RealizouCompra, setRealizouCompra] = useState("");
  const [LinkNavegacao, setLinkNavegacao] = useState("");
  const [cnpjRepresentante, setCnpjRepresentante] = useState("");
  const [vendedorMatricula, setVendedorMatricula] = useState("");
  const [nomeProduto, setNomeProduto] = useState("");
  const [loteProduto, setLoteProduto] = useState("");
  const [BAT, setBAT] = useState("");
  const [dataFabricacao, setDataFabricacao] = useState(new Date());
  const [mostraDataFabricacao, setMostraDataFabricacao] = useState(false);
  const [dataVencimento, setDataVencimento] = useState(new Date());
  const [mostraDataVencimento, setMostraDataVencimento] = useState(false);
  const [horaFabricacao, setHoraFabricacao] = useState(new Date());
  const [mostraHoraFabricacao, setMostraHoraFabricacao] = useState(false);
  const [qntReclamada, setQntReclamada] = useState(0);
  const [motivoReclamacao, setMotivoReclamacao] = useState("");
  const [nomeCliente, setNomeCliente] = useState("");
  const [telCliente, setTelCliente] = useState("");
  const [EscolhaMotivoReclamacao, setEscolhaMotivoReclamacao] = useState(0);
  const [MotivoReclamacaoFilho, setMotivoReclamacaoFilho] = useState(0);
  const [ListaMotivoReclamacao, setListaMotivoReclamacao] = useState([]);
  const [c_tipo, setc_tipo] = useState(0);
  const [data1, setData1] = useState("");
  const [hora, setHora] = useState(new Date().toLocaleTimeString());
  const [data2, setData2] = useState("");
  const [hora2, setHora2] = useState(new Date().toLocaleTimeString());
  const [DiaSemana, setDiaSemana] = useState("");
  const [ListaDiasSemana, setListaDiasSemana] = useState([
    { id: 1, checkbox: false, nome: "Segunda-feira" },
    { id: 2, checkbox: false, nome: "Terça-feira" },
    { id: 3, checkbox: false, nome: "Quarta-feira" },
    { id: 4, checkbox: false, nome: "Quinta-feira" },
    { id: 5, checkbox: false, nome: "Sexta-feira" },
    { id: 6, checkbox: false, nome: "Sábado" },
  ]);

  useEffect(() => {
    if (Token === null) {
      history.push({ pathname: "/", state: {} });
    } else {
      LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor");
    }
  }, []);

  const GreenRadio = withStyles({
    root: {
      color: "#DDDDDD",
      "&$checked": {
        color: "#FFFFFF",
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  function ValidaData(input) {
    var VerificaData =
      /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true;
    } else {
      return false;
    }
  }

  function ValidaHora(input) {
    var VerificaData =
      /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
    if (input.match(VerificaData)) {
      return true;
    } else {
      return false;
    }
  }

  const EnviarRequisicao = async (data, e) => {
    if (c_tipo.toString() === "13") {
      EnviarCorretiva(data);
      return false;
    }

    if (data.c_tipo == 0) {
      AlertForm("Você precisa selecionar o tipo de atendimento");
      e.preventDefault();
      return false;
    }

    if (data.c_tipo_email !== undefined && data.c_tipo_email !== "") {
      console.log("****", data.c_tipo_email);
      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!reg.test(data.c_tipo_email)) {
        AlertForm("Você precisa informar um e-mail válido");
        e.preventDefault();
        return false;
      }
    }

    if (data.c_tipo_detalhe == null || data.c_tipo_detalhe == "") {
      AlertForm("Você precisa detalhar o tipo de atendimento");
      e.preventDefault();
      return false;
    }

    if (ClienteSelecionado == null || ClienteSelecionado == "") {
      AlertForm("Você precisa selecionar um cliente");
      e.preventDefault();
      return false;
    }

    if (CheckBoxEndereco === true) {
      if (data.c_endereco == null || data.c_endereco == "") {
        AlertForm("Você precisa informar o endereço do cliente");
        e.preventDefault();
        return false;
      }
      if (data.c_numero == null || data.c_numero == "") {
        AlertForm("Você precisa informar o número do endereço");
        e.preventDefault();
        return false;
      }
      if (data.c_cep == null || data.c_cep == "") {
        AlertForm("Você precisa informar o CEP do cliente");
        e.preventDefault();
        return false;
      }
      if (data.c_bairro == null || data.c_bairro == "") {
        AlertForm("Você precisa informar o bairro do endereço");
        e.preventDefault();
        return false;
      }
      if (data.c_cidade == null || data.c_cidade == "") {
        AlertForm("Você precisa informar a cidade do endereço");
        e.preventDefault();
        return false;
      }
      if (data.c_estado == "0") {
        AlertForm("Você precisa informar o estado");
        e.preventDefault();
        return false;
      }
    }

    if (ProdutoSelecionado == null || ProdutoSelecionado == "") {
      AlertForm("Você precisa selecionar um produto");
      e.preventDefault();
      return false;
    }

    if (data1 == null || data1 == "") {
      AlertForm("Qual a data que o cliente deseja a visita?");
      e.preventDefault();
      return false;
    }

    if (data2 === null || data2 === "") {
      AlertForm("Qual a data que o cliente deseja a visita?");
      e.preventDefault();
      return false;
    }

    if (!calculateDateDiff(data1, data2)) {
      AlertForm(
        "As datas precisam estar com diferença de no mínimo sete dias!"
      );
      e.preventDefault();
      return false;
    }

    if (hora == null || hora == "") {
      AlertForm("Qual a hora que o cliente deseja a visita?");
      e.preventDefault();
      return false;
    }
    if (hora2 == null || hora2 == "") {
      AlertForm("Qual a hora que o cliente deseja a visita?");
      e.preventDefault();
      return false;
    }
    if (
      data.c_tipo_quantidadeDias === null ||
      data.c_tipo_quantidadeDias === "" ||
      data.c_tipo_quantidadeDias < 1
    ) {
      AlertForm("Quantos dias irá durar o treinamento?");
      e.preventDefault();
      return false;
    }
    if (
      data.c_tipo_telefoneCliente === null ||
      data.c_tipo_telefoneCliente === ""
    ) {
      AlertForm("Qual o telefone do cliente?");
      e.preventDefault();
      return false;
    }
    if (
      data.c_tipo_telefoneVendedor === null ||
      data.c_tipo_telefoneVendedor === ""
    ) {
      AlertForm("Qual o telefone do vendedor?");
      e.preventDefault();
      return false;
    }

    if (PrecoPao == 0) {
      AlertForm("Qual o potencial de compra/mês do cliente?");
      e.preventDefault();
      return false;
    }

    console.log("data", data);

    // var Preco = PrecoPao
    // .replace("R$ ","")
    // .replace(".","")
    // .replace(",",".");

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      cnpj: data.ClienteCPNJ,
      statusAtendimento: 0,
      tipoAtendimento: Number(data.c_tipo),
      emailcliente: data.c_tipo_email,
      detalheAtendimento: data.c_tipo_detalhe,
      lojaId: ClienteID,
      produtoId: ProdutoID,
      DataVisitaSugerida:
        data1.split("/").reverse().join("-") + "T" + hora + ".000Z",
      DataVisitaSugerida2:
        data2.split("/").reverse().join("-") + "T" + hora2 + ".000Z",
      potencialCompra: PrecoPao,
      diaSemanaId: DiaSemana,
      enderecoDiferente: CheckBoxEndereco,
      rua: data.c_endereco,
      cep: data.c_cep,
      bairro: data.c_bairro,
      cidade: data.c_cidade,
      uf: data.c_estado,
      numero: data.c_numero,
      TelefoneCliente: data.c_tipo_telefoneCliente,
      TelefoneVendedor: data.c_tipo_telefoneVendedor,
      DuracaoTreinamento: data.c_tipo_quantidadeDias,
    });

    console.log(raw);

    setTextoAguarde(true);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${URLBunge}/api/Requisicoes/CadastrarRequisicao`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.sucesso === true) {
          setTextoAguarde(false);
          AlertRedirect(
            "Sua requisição foi cadastrada com sucesso!",
            LinkNavegacao,
            history
          );
        } else {
          setTextoAguarde(false);
          AlertForm(result.mensagem);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setTextoAguarde(false);
      });
  };

  function EnviarCorretiva(data, e) {
    let valida = false;

    if (data.vendedorMatricula == null || data.vendedorMatricula == "") {
      AlertForm("Você precisa informar a matrícula do representante");
      return false;
    }

    if (data.nomeProduto == null || data.nomeProduto == "") {
      AlertForm("Você precisa informar o nome do produto");
      return false;
    }

    if (data.loteProduto == null || data.loteProduto == "") {
      AlertForm("Você precisa informar o lote do produto");
      return false;
    }

    if (data.qntReclamada == null || data.qntReclamada == "") {
      AlertForm("Você precisa informar a quantidade reclamada");
      return false;
    }

    if (data.MotivoReclamacaoFilho == 0) {
      AlertForm("Você precisa informar o motivo da reclamação");
      return false;
    }

    if (data.nomeCliente == null || data.nomeCliente == "") {
      AlertForm("Você precisa informar o nome do cliente");
      return false;
    }

    if (data.telCliente == null || data.telCliente == "") {
      AlertForm("Você precisa informar o telefone do cliente");
      return false;
    }

    setTextoAguarde(true);

    if (!valida === true) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "bearer " + Token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        cnpj: ClienteCPNJ,
        matricula: data.vendedorMatricula,
        sap: ClienteSAP,
        nomeProduto: data.nomeProduto,
        lote: data.loteProduto,
        bat: data.BAT,
        dataFabricacao:
          data.dataFabricacao.substr(6, 12) +
          "-" +
          data.dataFabricacao.substr(3, 2) +
          "-" +
          data.dataFabricacao.substr(0, 2) +
          "T" +
          data.horaFabricacao.substr(0, 2) +
          ":" +
          data.horaFabricacao.substr(3, 2) +
          ":00.000Z",
        dataVencimento:
          data.dataVencimento.substr(6, 12) +
          "-" +
          data.dataVencimento.substr(3, 2) +
          "-" +
          data.dataVencimento.substr(0, 2) +
          "T00:00:00.000Z",
        quantidadeReclamada: Number(data.qntReclamada),
        motivoReclamacaoId: Number(MotivoReclamacaoFilho),
        nome: data.nomeCliente,
        telefone: data.telCliente,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${URLBunge}/api/Requisicoes/RequisicaoFormulario`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.sucesso === true) {
            setTextoAguarde(false);

            AlertForm("Formulário cadastrado com sucesso!", result.mensagem);

            setCnpjRepresentante("");
            setVendedorMatricula("");
            setNomeProduto("");
            setLoteProduto("");
            setBAT("");
            setDataFabricacao(new Date());
            setDataVencimento(new Date());
            setHoraFabricacao(new Date());
            setQntReclamada("");
            setNomeCliente("");
            setTelCliente("");
            setEscolhaMotivoReclamacao(0);
            setMotivoReclamacaoFilho(0);
          } else {
            setTextoAguarde(false);
            AlertForm("Algo deu errado", result.mensagem);
          }
        })
        .catch((error) => console.log("error", error));
    }
  }

  const [ListaTipoAtendimento, setListaTipoAtendimento] = useState([]);
  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${URLBunge}/api/Requisicoes/ListaRequisicoesTipo`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        for (let i = 0; i < result.listaTipos.length; i = i + 1) {
          setListaTipoAtendimento((ListaTipoAtendimento) => [
            ...ListaTipoAtendimento,
            {
              value: result.listaTipos[i].idTipo,
              label: result.listaTipos[i].descricao,
            },
          ]);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  const Estados = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" },
  ];

  const BuscaCliente = async (data, e) => {
    // console.log(data);

    if (data.c_razaosap == undefined || data.c_razaosap.length < 5) {
      AlertForm("Você precisa digitar no mínimo 5 dígitos");
      e.preventDefault();
      return false;
    }

    setClienteMostra(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${URLBunge}/api/Pesquisa/ListarRazaoSap/` +
        CPFUser +
        "/" +
        data.c_razaosap,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setCarregandoBusca(false);
        if (result.outEntidades.length > 0) {
          setDadosClienteFlatlist(result.outEntidades);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const BuscaIndustria = async (data, e) => {
    // console.log(data);

    if (data.c_industria == undefined || data.c_industria.length < 3) {
      AlertForm("Você precisa digitar no mínimo 3 dígitos");
      e.preventDefault();
      return false;
    }

    setProdutoMostra(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${URLBunge}/api/Requisicoes/ListarProdutos/` + data.c_industria,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setCarregandoBusca(false);
        if (result.listaProdutos.length > 0) {
          setDadosProdutoFlatlist(result.listaProdutos);
        }
      })
      .catch((error) => console.log("error", error));
  };

  function LoadBusca() {
    return (
      <>
        <div>Carregando...</div>
      </>
    );
  }

  function addDays(date, days) {
    const Dia = new Date(Number(date));
    Dia.setDate(date.getDate() + days);
    return Dia;
  }

  function SelecionaCliente(ClienteNome, ClienteCPNJ, ClienteSAP, ClienteID) {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
    setClienteNome(ClienteNome);
    setClienteCPNJ(ClienteCPNJ);
    setClienteSAP(ClienteSAP);
    setClienteID(ClienteID);
    setClienteSelecionado(true);
    setValue("c_razaosap", "");
  }

  function FecharBuscaCliente() {
    setClienteMostra(false);
    setCarregandoBusca(true);
    setDadosClienteFlatlist([]);
  }

  function FecharBuscaProduto() {
    setProdutoMostra(false);
    setCarregandoBusca(true);
    setDadosProdutoFlatlist([]);
  }

  function SelecionaProduto(
    ProdutoNome,
    ProdutoMarca,
    ProdutoCategoria,
    ProdutoID
  ) {
    setProdutoMostra(false);
    setCarregandoBusca(true);
    setDadosProdutoFlatlist([]);
    setProdutoNome(ProdutoNome);
    setProdutoMarca(ProdutoMarca);
    setProdutoCategoria(ProdutoCategoria);
    setProdutoID(ProdutoID);
    setProdutoSelecionado(true);
    setValue("c_industria", "");

    var filtrado = ListaProdutos.filter(function (arr) {
      return arr.id == ProdutoID;
    });
    if (filtrado.length > 0) {
      Swal.fire({
        icon: "info",
        title: "Você pode escolher outro produto.",
        text: "Este produto já foi adicionado!",
      });
    } else {
      setListaProdutos((ListaProdutos) => [
        ...ListaProdutos,
        {
          nome: ProdutoNome,
          marca: ProdutoMarca,
          categoria: ProdutoCategoria,
          id: ProdutoID,
        },
      ]);
    }
  }

  function RemoverProdutos(ProdutoID) {
    setListaProdutos((prev) => prev.filter((item) => item.id !== ProdutoID));
  }

  const renderItem = (item, index) => (
    <ItemListaBusca
      key={index}
      onClick={() => SelecionaCliente(item.nome, item.cnpj, item.sap, item.id)}
    >
      <div className={"NomeCliente"}>{item.nome}</div>
      <div className={"CNPJSAP"}>
        <span>CPNJ</span> {MascaraCNPJ(item.cnpj)}
      </div>
      <div className={"CNPJSAP"}>
        <span>SAP</span> {item.sap}
      </div>
    </ItemListaBusca>
  );

  const renderItemProduto = (item, index) => (
    <ItemListaBusca
      key={index}
      onClick={() =>
        SelecionaProduto(item.descricao, item.codigo, item.grupo, item.id)
      }
    >
      <div className={"NomeCliente"}>{item.descricao}</div>
      <div className={"CNPJSAP"}>
        {" "}
        <span style={{ width: "60px" }}>CÓDIGO</span> {item.codigo}{" "}
      </div>
      <div className={"CNPJSAP"}>
        {" "}
        <span style={{ width: "60px" }}>GRUPO</span> {item.grupo}{" "}
      </div>
    </ItemListaBusca>
  );

  function MostraMotivoReclamacao() {
    for (let i = 0; i < ListaMotivoReclamacao.length; i = i + 1) {
      let item = ListaMotivoReclamacao[i].value;
      if (Number(item) === Number(EscolhaMotivoReclamacao)) {
        return (
          <CampoFormCadastro>
            <select
              onChange={(e) => {
                setMotivoReclamacaoFilho(e.target.value);
              }}
              name={"MotivoReclamacaoFilho"}
              id={"MotivoReclamacaoFilho"}
              ref={register}
            >
              <option value={0} disabled selected>
                Selecione uma opção
              </option>
              {ListaMotivoReclamacao[i].listaMotivosFilhos.map(
                (item, index) => {
                  return (
                    <>
                      <option value={item.value}>{item.label}</option>
                    </>
                  );
                }
              )}
            </select>
          </CampoFormCadastro>
        );
      }
    }
  }

  function InsereFilhos(itens) {
    var ListaFilhos = [];
    for (let i = 0; i < itens.length; i = i + 1) {
      ListaFilhos.push({
        value: itens[i].id,
        label: itens[i].descricao,
      });
    }
    return ListaFilhos;
  }

  function MostraBuscaCliente(props) {
    return (
      <>
        <BgModal>
          <ModalEvento>
            <div className={"TituloEvento"}>Busca de clientes</div>
            <Clear />
            <div className={"ListaClientes"} style={{ textAlign: "left" }}>
              <>
                {CarregandoBusca == true ? (
                  <LoadBusca />
                ) : DadosClienteFlatlist.length > 0 ? (
                  DadosClienteFlatlist.map((item, index) => {
                    return renderItem(item, index);
                  })
                ) : (
                  <div>
                    Nenhum cliente encontrado{"\n"}Verifique sua busca e tente
                    novamente.
                  </div>
                )}
              </>
            </div>
            <a className={"BtFecharModal"} onClick={() => FecharBuscaCliente()}>
              FECHAR
            </a>
          </ModalEvento>
        </BgModal>
      </>
    );
  }

  console.log("&&&&", ListaProdutos);

  function MostraProdutoCliente(props) {
    return (
      <>
        <BgModal>
          <ModalEvento>
            <div className={"TituloEvento"}>Busca de produtos</div>
            <Clear />
            <div className={"ListaClientes"} style={{ textAlign: "left" }}>
              <>
                {CarregandoBusca == true ? (
                  <LoadBusca />
                ) : DadosProdutoFlatlist.length > 0 ? (
                  DadosProdutoFlatlist.map((item, index) => {
                    return renderItemProduto(item, index);
                  })
                ) : (
                  <div>
                    Nenhum produto encontrado{"\n"}Verifique sua busca e tente
                    novamente.
                  </div>
                )}
              </>
            </div>
            <a className={"BtFecharModal"} onClick={() => FecharBuscaProduto()}>
              FECHAR
            </a>
          </ModalEvento>
        </BgModal>
      </>
    );
  }

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${URLBunge}/api/Requisicoes/ListaMotivos`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("KKKKKKKKKK", result);
        for (let i = 0; i < result.listaMotivos.length; i = i + 1) {
          setListaMotivoReclamacao((ListaMotivoReclamacao) => [
            ...ListaMotivoReclamacao,
            {
              value: result.listaMotivos[i].id,
              label: result.listaMotivos[i].descricao,
              listaMotivosFilhos: InsereFilhos(
                result.listaMotivos[i].listaMotivosFilhos
              ),
            },
          ]);
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  function calculateDateDiff(datafim, datainicio) {
    let formatedInicio = datainicio.split("/").reverse().join("-");
    let formatedFim = datafim.split("/").reverse().join("-");

    let inicio = formatedInicio;
    let fim = formatedFim;

    inicio = new Date(inicio);
    fim = new Date(fim);

    let diffIntime = Math.abs(fim - inicio);
    let timeInOneDay = 1000 * 60 * 60 * 24; //UM DIA EM MILISSEGUNDOS
    let diffInDays = diffIntime / timeInOneDay;

    if (diffInDays < 7) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if (Cargo == "2653") {
      setLinkNavegacao("/AcademiaFormularioCalendario");
    } else {
      setLinkNavegacao("/AcademiaFormularioListaRequisicoes");
    }
  }, []);

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        {ClienteMostra == true ? <MostraBuscaCliente /> : null}
        {ProdutoMostra == true ? <MostraProdutoCliente /> : null}

        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Requisição de Atendimento</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() =>
                history.push({ pathname: LinkNavegacao, state: {} })
              }
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>

            <FormPesquisa onSubmit={handleSubmit(EnviarRequisicao)}>
              <CampoFormCadastro>
                <select
                  onChange={(e) => setc_tipo(e.target.value)}
                  name={"c_tipo"}
                  id={"c_tipo"}
                  ref={register}
                >
                  <option value={0} disabled selected>
                    Qual o tipo de atendimento?
                  </option>
                  {ListaTipoAtendimento.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <option value={item.value}>{item.label}</option>{" "}
                      </>
                    );
                  })}
                </select>
              </CampoFormCadastro>
              <DescCampo>Qual o cliente?</DescCampo>
              {ClienteSelecionado == false ? (
                <CampoFormBusca>
                  <Controller
                    control={control}
                    ref={register}
                    id="c_razaosap"
                    name="c_razaosap"
                    type="text"
                    placeholder={"Razão social ou SAP"}
                    className="CampoForm CampoFormLogin"
                    as={InputMask}
                    mask=""
                  />
                  <BtIcoBuscar onClick={handleSubmit(BuscaCliente)}>
                    <img src={IcoBusca} />
                  </BtIcoBuscar>
                </CampoFormBusca>
              ) : (
                <ClienteProdutoSelecionado>
                  <div className={"NomeCliente"}>{ClienteNome}</div>
                  <div className={"CNPJSAP"}>
                    <span>CPNJ</span> {MascaraCNPJ(ClienteCPNJ)}
                  </div>
                  <div className={"CNPJSAP"}>
                    <span>SAP</span> {ClienteSAP}
                  </div>
                  <div
                    className={"BtAlterar"}
                    onClick={() => setClienteSelecionado(false)}
                  >
                    ALTERAR
                  </div>
                </ClienteProdutoSelecionado>
              )}
              {c_tipo.toString() === "13" ? (
                <>
                  <CampoFormCadastro>
                    <DescCampo>Identificação do representante</DescCampo>
                    <Controller
                      control={control}
                      ref={register}
                      id="vendedorMatricula"
                      name="vendedorMatricula"
                      type="text"
                      placeholder={"Matrícula"}
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask=""
                    />
                    <br />
                    <br />
                    <DescCampo>Informações do produto</DescCampo>
                    <CampoFormCadastro>
                      <Controller
                        control={control}
                        ref={register}
                        id="nomeProduto"
                        name="nomeProduto"
                        type="text"
                        placeholder={"Nome do Produto"}
                        className="CampoForm CampoFormLogin"
                        as={InputMask}
                        mask=""
                      />
                    </CampoFormCadastro>
                    <EndLinha04>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="loteProduto"
                          name="loteProduto"
                          type="text"
                          placeholder={"Lote"}
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                        />
                      </CampoFormCadastro>

                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="BAT"
                          name="BAT"
                          type="text"
                          placeholder={"BAT"}
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                        />
                      </CampoFormCadastro>
                    </EndLinha04>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <DescCampo>Data de Fabricação </DescCampo>
                      <DescCampo>Data de Vencimento </DescCampo>
                    </div>
                    <EndLinha04>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="dataFabricacao"
                          name="dataFabricacao"
                          type="text"
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                          mask="99/99/9999"
                        />
                      </CampoFormCadastro>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="dataVencimento"
                          name="dataVencimento"
                          type="text"
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                          mask="99/99/9999"
                        />
                      </CampoFormCadastro>
                    </EndLinha04>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <DescCampo>Horário de Fabricação</DescCampo>
                      <DescCampo>Quantidade Reclamada</DescCampo>
                    </div>
                    <EndLinha04>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="horaFabricacao"
                          name="horaFabricacao"
                          type="text"
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                          mask={"99:99"}
                        />
                      </CampoFormCadastro>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="qntReclamada"
                          name="qntReclamada"
                          type="text"
                          placeholder={"Quantidade"}
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                        />
                      </CampoFormCadastro>
                    </EndLinha04>
                    <DescCampo>Motivo da Reclamação</DescCampo>
                    <CampoFormCadastro>
                      <select
                        onChange={(e) => {
                          setEscolhaMotivoReclamacao(e.target.value);
                        }}
                        name={"EscolhaMotivoReclamacao"}
                        id={"EscolhaMotivoReclamacao"}
                        ref={register}
                      >
                        <option value={0} disabled selected>
                          Selecione uma opção
                        </option>
                        {ListaMotivoReclamacao.map((item, index) => {
                          return (
                            <>
                              {" "}
                              <option value={item.value}>
                                {item.label}
                              </option>{" "}
                            </>
                          );
                        })}
                      </select>
                    </CampoFormCadastro>
                    {MostraMotivoReclamacao()}
                    <DescCampo>Contato do Cliente</DescCampo>
                    <EndLinha04>
                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="nomeCliente"
                          name="nomeCliente"
                          type="text"
                          placeholder={"Nome"}
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                        />
                      </CampoFormCadastro>

                      <CampoFormCadastro>
                        <Controller
                          control={control}
                          ref={register}
                          id="telCliente"
                          name="telCliente"
                          type="text"
                          placeholder={"Telefone"}
                          className="CampoForm CampoFormLogin"
                          as={InputMask}
                          mask={"(11) 99999-9999"}
                        />
                      </CampoFormCadastro>
                    </EndLinha04>
                  </CampoFormCadastro>
                </>
              ) : (
                <>
                  <CampoFormCadastro>
                    <Controller
                      control={control}
                      ref={register}
                      id="c_tipo_email"
                      name="c_tipo_email"
                      type="text"
                      placeholder={"E-mail do cliente"}
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask=""
                    />
                  </CampoFormCadastro>
                  <CampoFormCadastro>
                    <Controller
                      control={control}
                      ref={register}
                      id="c_tipo_detalhe"
                      name="c_tipo_detalhe"
                      type="text"
                      placeholder={"Detalhe o tipo de atendimento"}
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask=""
                    />
                  </CampoFormCadastro>
                  <br />
                  <CampoFormCadastro>
                    <BtCheckBox
                      onClick={() => setCheckBoxEndereco(!CheckBoxEndereco)}
                    >
                      <input
                        name="isGoing"
                        type="checkbox"
                        checked={CheckBoxEndereco}
                        onChange={() => setCheckBoxEndereco(!CheckBoxEndereco)}
                      />
                      <span>Endereço de atendimento diferente?</span>
                    </BtCheckBox>
                  </CampoFormCadastro>

                  {CheckBoxEndereco === true ? (
                    <>
                      <EndLinha01>
                        <CampoFormCadastro>
                          <Controller
                            control={control}
                            ref={register}
                            id="c_endereco"
                            name="c_endereco"
                            type="text"
                            placeholder={"Endereço"}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                          />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                          <Controller
                            control={control}
                            ref={register}
                            id="c_numero"
                            name="c_numero"
                            type="text"
                            placeholder={"Número"}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                          />
                        </CampoFormCadastro>
                      </EndLinha01>

                      <EndLinha02>
                        <CampoFormCadastro>
                          <Controller
                            control={control}
                            ref={register}
                            id="c_cep"
                            name="c_cep"
                            type="text"
                            placeholder={"CEP"}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask="99999-999"
                          />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                          <Controller
                            control={control}
                            ref={register}
                            id="c_bairro"
                            name="c_bairro"
                            type="text"
                            placeholder={"Bairro"}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                          />
                        </CampoFormCadastro>
                      </EndLinha02>

                      <EndLinha03>
                        <CampoFormCadastro>
                          <Controller
                            control={control}
                            ref={register}
                            id="c_cidade"
                            name="c_cidade"
                            type="text"
                            placeholder={"Cidade"}
                            className="CampoForm CampoFormLogin"
                            as={InputMask}
                            mask=""
                          />
                        </CampoFormCadastro>

                        <CampoFormCadastro>
                          <select
                            name={"c_estado"}
                            id={"c_estado"}
                            ref={register}
                          >
                            <option value={0} disabled selected>
                              Selecione
                            </option>
                            {Estados.map((item, index) => {
                              return (
                                <>
                                  {" "}
                                  <option value={item.value}>
                                    {item.label}
                                  </option>{" "}
                                </>
                              );
                            })}
                          </select>
                        </CampoFormCadastro>
                      </EndLinha03>
                    </>
                  ) : null}

                  <br />
                  <DescCampo>Qual o produto foco do atendimento?</DescCampo>
                  {ListaProdutos.length < 5 && (
                    <CampoFormBusca>
                      <Controller
                        control={control}
                        ref={register}
                        id="c_industria"
                        name="c_industria"
                        type="text"
                        placeholder={"Indústria, marca ou SKU"}
                        className="CampoForm CampoFormLogin"
                        as={InputMask}
                        mask=""
                      />
                      <BtIcoBuscar onClick={handleSubmit(BuscaIndustria)}>
                        <img src={IcoBusca} />
                      </BtIcoBuscar>
                    </CampoFormBusca>
                  )}
                  {ListaProdutos.map((item) => {
                    return (
                      <ClienteProdutoSelecionado>
                        <div className={"NomeCliente"}>{ProdutoNome}</div>
                        <div className={"MarcaCategoriaPeso"}>
                          <span>CÓDIGO</span> {item.marca}
                        </div>
                        {/* <div className={"MarcaCategoriaPeso"}>
                          <span>Categoria</span> {ProdutoCategoria}
                        </div> */}
                        <div className={"MarcaCategoriaPeso"}>
                          <span>GRUPO</span> {item.categoria}
                        </div>
                        <div
                          className={"BtAlterar"}
                          onClick={() => RemoverProdutos(item.id)}
                        >
                          REMOVER PRODUTO
                        </div>
                      </ClienteProdutoSelecionado>
                    );
                  })}

                  <br />
                  <DescCampo>
                    Indique 2 datas de preferência do cliente para o
                    atendimento.
                    <br />
                    <small>* Com uma semana de diferença no mínimo</small>
                  </DescCampo>

                  <EndLinha04>
                    <CampoFormCadastro>
                      <small>1ª opção de data</small>
                      <InputMask
                        id="c_data"
                        name="c_data"
                        type="text"
                        value={data1}
                        onChange={(event) => setData1(event.target.value)}
                        placeholder={"Data"}
                        className="CampoForm CampoFormLogin"
                        mask="99/99/9999"
                      />
                    </CampoFormCadastro>

                    <CampoFormCadastro>
                      <small>2ª opção de data</small>
                      <InputMask
                        id="c_data2"
                        name="c_data2"
                        type="text"
                        value={data2}
                        onChange={(event) => {
                          setData2(event.target.value);
                        }}
                        placeholder={"Data"}
                        className="CampoForm CampoFormLogin"
                        mask={"99/99/9999"}
                      />
                    </CampoFormCadastro>
                  </EndLinha04>

                  <EndLinha04>
                    <CampoFormCadastro>
                      <small>Entre a hora:</small>
                      <InputMask
                        id="c_hora"
                        name="c_hora"
                        type="text"
                        onChange={(event) => setHora(event.target.value)}
                        value={hora.substr(0, 5)}
                        placeholder={"Hora"}
                        className="CampoForm CampoFormLogin"
                        as={InputMask}
                        mask={"99:99"}
                      />
                    </CampoFormCadastro>

                    <CampoFormCadastro>
                      <small>E a hora:</small>
                      <InputMask
                        id="c_hora2"
                        name="c_hora2"
                        type="text"
                        onChange={(event) => setHora2(event.target.value)}
                        value={hora2.substr(0, 5)}
                        placeholder={"Hora"}
                        className="CampoForm CampoFormLogin"
                        mask={"99:99"}
                      />
                    </CampoFormCadastro>
                  </EndLinha04>
                  <small>* Aguarde a confirmação do time da academia</small>
                  <br />
                  <br />
                  <DescCampo>
                    Se for um treinamento, indique a quantidade de dias:
                  </DescCampo>
                  <CampoFormCadastro>
                    <Controller
                      control={control}
                      ref={register}
                      id="c_tipo_quantidadeDias"
                      name="c_tipo_quantidadeDias"
                      type="text"
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask="99"
                    />
                  </CampoFormCadastro>
                  <br />
                  <DescCampo>
                    Selecione em qual dia da semana o cliente prefere receber a
                    visita
                  </DescCampo>

                  {ListaDiasSemana.map((item, index) => {
                    return (
                      <CampoFormCadastro>
                        <Button
                          onClick={() => setDiaSemana(item.id)}
                          style={{
                            backgroundColor:
                              item.id === DiaSemana ? "#3fb6fc" : "#c2c2c2",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          {item.nome}
                        </Button>
                      </CampoFormCadastro>
                    );
                  })}

                  <br />
                  <DescCampo>
                    Qual o potencial de compra/mês do cliente?
                  </DescCampo>
                  <CampoFormCadastro>
                    <CurrencyInput
                      id="c_preco"
                      name="c_preco"
                      prefix=""
                      decimalSeparator="."
                      thousandSeparator="."
                      precision="3"
                      maxlength="7"
                      value={PrecoPao}
                      onChange={(_, valor) => setPrecoPao(valor)}
                    />
                  </CampoFormCadastro>
                  <br />
                  <DescCampo>Contatos</DescCampo>
                  <CampoFormCadastro>
                    <small style={{ textAlign: "left" }}>
                      Telefone do vendedor/representante
                    </small>
                    <Controller
                      control={control}
                      ref={register}
                      id="c_tipo_telefoneVendedor"
                      name="c_tipo_telefoneVendedor"
                      type="text"
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask="(99)99999-9999"
                    />
                  </CampoFormCadastro>
                  <CampoFormCadastro>
                    <small>Telefone do cliente</small>
                    <Controller
                      control={control}
                      ref={register}
                      id="c_tipo_telefoneCliente"
                      name="c_tipo_telefoneCliente"
                      type="text"
                      className="CampoForm CampoFormLogin"
                      as={InputMask}
                      mask="(99)99999-9999"
                    />
                  </CampoFormCadastro>
                </>
              )}

              <Clear />
              {TextoAguarde === false ? (
                <BotaoEnviarPesquisa type="submit">
                  ENVIAR REQUISIÇÃO
                </BotaoEnviarPesquisa>
              ) : (
                <BotaoEnviarPesquisa disabled>AGUARDE...</BotaoEnviarPesquisa>
              )}

              <Clear />
            </FormPesquisa>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default AcademiaFormularioAtendimento;
